import React from "react";
import { translateText } from "../../../../../../Helper_functions";

const ReasonPopup = (props) => {
  return (
    <div
      className={
        props.LastJPAaction === "like"
          ? "reason-wrapper on-like"
          : "reason-wrapper on-dislike"
      }
    >
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="reason-popup">
        <section className="popup-head">
          <h1>
            {props.LastJPAaction === "like"
              ? translateText("why_do_you_like_it", props.LangData)
              : translateText("why_do_you_dislike_it", props.LangData)}
          </h1>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </section>
        <section className="reason-chips-holder">
          {props.Reasons.map((Reason) => (
            <span
              className={Reason.selected ? "reason selected-reason" : "reason"}
              onClick={() => props.SelectReasonItem(Reason)}
            >
              {translateText(Reason.name, props.LangData)}
            </span>
          ))}
        </section>
      </div>
      <span className="small-tip"></span>
    </div>
  );
};

export default ReasonPopup;
